import { Form } from 'semantic-ui-react';
import { Link } from "react-router-dom";
import { LoadingWrapper } from '../common';
import { AssetSelector } from './AssetSelector';
import { InspectionFields } from './InspectionFields';
import { ImageUploader } from './ImageUploader';
import { InspectionDetails } from './InspectionDetails';
import { ActionButtons } from './ActionButtons';
import { ConfirmationPopup } from '../common/ConfirmationPopup';
import { useAssetInspectionForm } from './useAssetInspectionForm';

export const AssetInspectionForm = ({ mode = 'create' }) => {
  const {
    assets,
    selectedAsset,
    fieldValues,
    groupedFields,
    images,
    existingImages,
    success,
    fieldErrors,
    formErrors,
    showPopup,
    setShowPopup,
    popupContent,
    popupError,
    imageError,
    pendingInspection,
    loaded,
    assetInspection,
    showConfirmPopup,
    statusConfirmPopup,
    setShowConfirmPopup,
    failedFields,
    standdownEnabled,
    handleAssetChange,
    handleChange,
    handleImageChange,
    handleRemoveImage,
    handleImageDelete,
    handleFieldChange,
    handleSubmit,
    handleSaveDraft,
    handleApprove,
    handleDeny,
    handlePopupClose
  } = useAssetInspectionForm({ mode });

  const isEdit = mode === 'edit';

  if (pendingInspection.length && !isEdit) {
    return (
      <div>
        There is already an <Link to={'../' + pendingInspection[0].id}>open inspection</Link>. 
        Please resolve that one first.
      </div>
    );
  }

  const standdownNotRequired = !isEdit && selectedAsset && loaded && !standdownEnabled;

  return (
    <>
      <ConfirmationPopup
        show={showPopup}
        error={popupError}
        content={popupContent}
        showConfirm={showConfirmPopup}
        failedFields={failedFields}
        onConfirm={() => {
          setShowPopup(false);
          setShowConfirmPopup(false);
          handleSubmit(statusConfirmPopup, true);
        }}
        onCancel={() => {
          setShowPopup(false);
          setShowConfirmPopup(false);
        }}
        onClose={handlePopupClose}
      />
      <LoadingWrapper loading={!loaded}>
        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <div id="asset-form-wrapper" style={{
            minWidth: "15rem",
            maxWidth: "40rem",
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            <Form success={success}>
              <AssetSelector
                assets={assets}
                selectedAsset={selectedAsset}
                onChange={handleAssetChange}
                isEdit={isEdit}
              />

              {standdownNotRequired ? (
                <div data-testid="standdown-not-required">
                  Monthly standdown is not required for this asset type.
                </div>
              ) : (
                <>
                  <InspectionFields
                    groupedFields={groupedFields}
                    fieldValues={fieldValues}
                    fieldErrors={fieldErrors}
                    handleChange={handleChange}
                  />

                  <ImageUploader
                    images={images}
                    existingImages={existingImages}
                    imageError={imageError}
                    handleImageChange={handleImageChange}
                    handleRemoveImage={handleRemoveImage}
                    handleImageDelete={handleImageDelete}
                    isEdit={isEdit}
                    fieldValues={fieldValues}
                  />

                  {fieldValues.length > 0 && (
                    <InspectionDetails
                      assetInspection={assetInspection}
                      handleFieldChange={handleFieldChange}
                      formErrors={formErrors}
                      isEdit={isEdit}
                    />
                  )}

                  <ActionButtons
                    isEdit={isEdit}
                    assetInspection={assetInspection}
                    formErrors={formErrors}
                    handleFieldChange={handleFieldChange}
                    handleApprove={handleApprove}
                    handleDeny={handleDeny}
                    handleSubmit={handleSubmit}
                    handleSaveDraft={handleSaveDraft}
                    fieldValues={fieldValues}
                  />
                </>
              )}
            </Form>
          </div>
        </div>
      </LoadingWrapper>
    </>
  );
};
